import { useTranslation } from 'react-i18next';
import { faCalendarCircleUser } from '@fortawesome/pro-regular-svg-icons/faCalendarCircleUser';
import { faUserPen } from '@fortawesome/pro-regular-svg-icons/faUserPen';
import { Button, Flex, theme } from 'antd';
import { PosCard } from 'pos-client/components/shared/Display/Card/PosCard.tsx';
import { PosModal } from 'pos-client/components/shared/Display/Modal/PosModal.tsx';
import { UserShift } from 'pos-client/components/users/UserCrud/UserShift/UserShift.tsx';
import { type UserModel } from 'pos-shared/models/userSchema';

interface UserShiftModalProps {
  user: UserModel | null;
  isModalOpen: boolean;
  handleCancel: () => void;
}

export const UserShiftModal = ({
  user,
  isModalOpen = false,
  handleCancel,
}: UserShiftModalProps) => {
  const { t } = useTranslation();
  const { token } = theme.useToken();

  return (
    <PosModal
      open={isModalOpen}
      header={{
        title: t('locations.users.quickViewSchedule'),
        icon: faUserPen,
      }}
      onCancel={handleCancel}
      width={token.screenXXL}
      height={token.screenMD}
      footer={
        <Flex justify="start" align="center" gap="small">
          <Button type="default" onClick={handleCancel}>
            {t('common.buttons.back')}
          </Button>
        </Flex>
      }
    >
      <Flex vertical justify="center" align="center" gap="small">
        <PosCard
          headerProps={{
            title: `${user?.fullName} ${t('locations.users.shifts')}`,
            icon: faCalendarCircleUser,
          }}
          styles={{ body: { padding: 10 } }}
        >
          <UserShift userId={user?.id} />
        </PosCard>
      </Flex>
    </PosModal>
  );
};
